module.exports = __webpack_public_path__ + "img/samsung-galaxy-book-s.77c8d09.jpg";